import { useContext } from 'react';
import { createContext } from 'react';

import { RatingSummaryProps } from '../@types/RatingSummaryProps';

export const RatingSummaryContext = createContext<RatingSummaryProps>({} as RatingSummaryProps);

RatingSummaryContext.displayName = 'RatingSummary';

const RatingSummaryProvider = (props: RatingSummaryProps) => (
	<RatingSummaryContext.Provider value={props}>{props.children}</RatingSummaryContext.Provider>
);

export const useRatingSummary = () => {
	const context = useContext(RatingSummaryContext);

	return context;
};

export default RatingSummaryProvider;
